import { Autocomplete, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil';
import { valuesFormRegisterState, errorsReservationGuestState } from 'src/Patient/state/atoms';
import InputLabelCustom from 'src/shared/components/forms/InputLabelCustom'
import { finderCovenantByName } from 'src/shared/global/helpers';
import useCatchErrorApi from 'src/shared/hooks/useCatchErrorApi';
import { userState } from 'src/store/user/userState';
import { covenantsBaseFetchState, covenantsBaseState } from '../register/state/atoms';

const PrevisionAutocomplete = () => {
    const { catchErrorApi } = useCatchErrorApi();
    const [{ isaNombre }, setValuesFormRegister] = useRecoilState(valuesFormRegisterState);
    const [covenantsBase, setCovenantsBase] = useRecoilState(covenantsBaseState);
    const [errorsReservationGuest, setErrorsReservationGuest] = useRecoilState(errorsReservationGuestState);

    const user = useRecoilValue(userState);

    const loadCovenantsBase = useRecoilCallback(({ snapshot }) => async () => {
        //setLoading(true)
        try {
            const covenantsFetch = await snapshot.getPromise(covenantsBaseFetchState);
            setCovenantsBase(covenantsFetch)

        } catch (error) {
            catchErrorApi(error);
        } finally {
            //setLoading(false)
        }
    }, []);

    useEffect(() => {
        loadCovenantsBase()
    }, [loadCovenantsBase])

    useEffect(() => {
        if(user.payload) {
            setValuesFormRegister((currentState) => ({
                ...currentState,
                isaCodigo: user.payload.isaCodigo,
                isaNombre: user.payload.isaNombre
            }))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])


    return (
        <>
            <Autocomplete
                size="small"
                id="autocomplete-prevision"
                options={covenantsBase.map((option) => `${option.nombre}`)}
                getOptionLabel={option => option || null}
                value={isaNombre || null}
                noOptionsText="Sin resultados"
                onChange={(event, newInputValue, reason) => {
                    
                    if (errorsReservationGuest.hasOwnProperty('isaCodigo')) {
                        setErrorsReservationGuest({ ...errorsReservationGuest, isaCodigo: [] });
                    }

                    if (reason === 'clear') {
                        setValuesFormRegister((currentState) => ({
                            ...currentState,
                            isaCodigo: null,
                            isaNombre: null
                        }));

                        // if(user.payload) {
                        //     setUser({
                        //         ...user,
                        //         payload: {
                        //             ...user.payload,
                        //             isaNombre: null,
                        //             isaCodigoImed: null,
                        //             isaCodigo: null
                        //         }
                        //     })
                        // }

                        return;
                    }

                    if (reason === 'selectOption') {
                        const finderCovenant = finderCovenantByName(covenantsBase, newInputValue);
                        setValuesFormRegister((currentState) => ({
                            ...currentState,
                            isaCodigo: finderCovenant.codigo,
                            isaCodigoImed: finderCovenant.isaCodigoImed,
                            isaNombre: finderCovenant.nombre
                        }));
                    }
                }}
                renderInput={
                    (params) => 
                    <TextField {...params} 
                        placeholder="Seleccione previsión" 
                        variant="outlined" 
                        error={errorsReservationGuest['isaCodigo'] && errorsReservationGuest['isaCodigo'].length > 0 ? true : false}
                        helperText={errorsReservationGuest['isaCodigo'] && errorsReservationGuest['isaCodigo'].length > 0 ? `${errorsReservationGuest['isaCodigo'].join("\n")}` : ''}
                    />
                }
            />
        </>
    )
}

export default PrevisionAutocomplete
